// extracted by mini-css-extract-plugin
export default {"table":"Administrators_table__Kfj6w"};